const sharedConfig = {
    SENTRY_RELEASE: "",
    SENTRY_DSN: "https://c879b80b1fe34674b91166b2271e7ad1@o478484.ingest.sentry.io/4505036841287680",
    VITE_TRACKER_URL: "",
    BASE_URL: "",
    MODE: "",
    DEV: false,
    PROD: false,
    SSR: false,
    VITE_APP_CLIENT_ID: "ca1e6eb0-29a0-4f90-9c4b-e7cc6e4e4750",
    OPP_AUTHZ: "true",
    USER_MANUAL_URL: "",
    ADMIN_GROUP_IDS: "2e894baa-ba93-438c-8dd3-76041dbdaaf9,2f9847ea-654e-4d38-b29d-8951ba615e45",
};
const OPP_PARCEL_CONFIG = {
    dev: {
        VITE_APP_TENANT_ID: "720b637a-655a-40cf-816a-f22f40755c2c",
        VITE_API_URL_FORECAST: "https://forecasting-dev.ingkadt.com/api",
        ENVIRONMENT: "dev-v1",
        ...sharedConfig,
    },
    stage: {
        VITE_APP_TENANT_ID: "720b637a-655a-40cf-816a-f22f40755c2c",
        VITE_API_URL_FORECAST: "https://forecasting-stage.ingkadt.com/api",
        ENVIRONMENT: "stage-v1",
        ...sharedConfig,
    },
    prod: {
        VITE_APP_TENANT_ID: "720b637a-655a-40cf-816a-f22f40755c2c",
        VITE_API_URL_FORECAST: "https://forecasting.ingka.com/api",
        ENVIRONMENT: "prod-v1",
        ...sharedConfig,
    },
};
const prodOPP = "peopleplanning.ingka.com";
const h = window.location.hostname;
const OPP_ENV = h.includes("stage")
    ? "stage"
    : h === prodOPP
        ? "prod"
        : "stage";
console.info(`Running Parcel in forecasting client ${OPP_ENV} environment`);
function get(key) {
    const c = window.__RUNTIME_CONFIG__ ?? OPP_PARCEL_CONFIG[OPP_ENV];
    if (c !== undefined && typeof c === "object") {
        return c[key] ?? "";
    }
    console.error(`Config for environment "${OPP_ENV}" not found workload drivers`);
    return "";
}
function getWithFallback(key) {
    const windowConfig = window.__RUNTIME_CONFIG__;
    const oppConfig = OPP_PARCEL_CONFIG[OPP_ENV];
    return windowConfig !== undefined &&
        typeof windowConfig === "object" &&
        windowConfig[key] !== undefined
        ? windowConfig[key]
        : oppConfig[key];
}
export const ENVIRONMENT = get("ENVIRONMENT");
export const SENTRY_RELEASE = get("SENTRY_RELEASE");
export const SENTRY_DSN = get("SENTRY_DSN");
export const VITE_APP_CLIENT_ID = get("VITE_APP_CLIENT_ID");
export const VITE_APP_TENANT_ID = get("VITE_APP_TENANT_ID");
export const VITE_API_URL_FORECAST = get("VITE_API_URL_FORECAST");
export const VITE_TRACKER_URL = get("VITE_TRACKER_URL");
export const USER_MANUAL_URL = getWithFallback("USER_MANUAL_URL");
export const ADMIN_GROUP_IDS = get("ADMIN_GROUP_IDS");
export const OPP_AUTHZ = getWithFallback("OPP_AUTHZ") === "true";
//# sourceMappingURL=runtimeConfig.js.map